import { render, staticRenderFns } from "./LoginBvs.vue?vue&type=template&id=31a0d9b0"
import script from "./LoginBvs.vue?vue&type=script&lang=js"
export * from "./LoginBvs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a0d9b0')) {
      api.createRecord('31a0d9b0', component.options)
    } else {
      api.reload('31a0d9b0', component.options)
    }
    module.hot.accept("./LoginBvs.vue?vue&type=template&id=31a0d9b0", function () {
      api.rerender('31a0d9b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LoginBvs.vue"
export default component.exports